export default {
  title: 'Aplikacja mobilna',
  fields: {
    name: 'Nazwa aplikacji',
  },
  buttons: {
    save: 'Zapisz',
  },
};
